<template>
  <div class="card shadow mt-2 mb-3 border-0" style="position:relative;">
    <div class="card-body">
      <div class="title">
        <div class="wrap">
          <h5>График автоматического сбора</h5>
          <div class="sub-title">Настройте частоту и время запуска парсера</div>
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          <div class="rounded border border-opacity-25 border-secondary p-2 mb-3" v-for="(type, index) in day_types">
            <div class="form-check">
              <input class="form-check-input" :value="type.value" :checked="type.value===day_type" @change="day_type=type.value" type="radio" name="day_type" :id="'radioDefault'+index">
              <label class="form-check-label" :for="'radioDefault'+index">
                {{ type.name }}
                <span class="help-text">
      {{ type.help }}
    </span>
              </label>
            </div>
          </div>
          <div class="weekdays-selector" v-if="day_type==='few_days'">
    <div class="btn-group" role="group">
      <button
        v-for="day in weekdays"
        :key="day.id"
        type="button"
         @click="toggleDay(day.id)"
        :class="{ active: settings.restart_weekday?.includes(day.id) }"
        class="btn btn-outline-primary btn-sm"
        :title="day"
      >
        {{ day.name }}
      </button>
    </div>
  </div>

        </div>
        <div class="col-6">
          <div class="rounded border border-opacity-25 border-secondary p-2 mb-2" v-for="(time, index)  in settings.restart_times">
                    <date-picker v-model="settings.restart_times[index]"
                     locale="ru"
                     :clearable="false"
                     format="HH:mm"
                     model-type="HH:mm:ss"
                     auto-apply
                     :timePicker="true"
                     :enable-time-picker="true"></date-picker>


          </div>
          <button v-if="$store.getters.tariff.max_per_day > settings.restart_times?.length" class="add-time btn" @click="settings.restart_times.push('00:00:00')">+ Добавить время</button>

        </div>
      </div>
      <div class="row parser-days">
        <div class="col-lg-4">
          <p>Глубина сбора данных</p>
          <div class="d-flex">
            <div class="">
              <input id="name" v-model="settings.restart_day_back" :max="$store.getters.tariff.max_period" class="form-control" placeholder="7" type="number"  @input="validateMax" autocomplete="off">
            </div>
            <label for="">{{$pluralise(1, ['день','дня','дней'], false)}} назад от текущей даты</label>
          </div>
          <div class="help-text">По умолчанию 7 дней. Парсер будет собирать отзывы за последние N дней</div>
        </div>
      </div>
      <div class="row parser-days">
        <div class="col-lg-4 pt-3">
          <p>Частота запуска сбора отзывов по ссылкам для регулярных проверок </p>
          <div class="d-flex">
            <div class="">
              <input id="name" v-model="settings.restart_checker_period" max="60" :min="$store.getters.tariff.min_period_checker" class="form-control" :placeholder="$store.getters.tariff.min_period_checker" type="number"  @input="validateMin" autocomplete="off">
            </div>
            <label for="">минут</label>
          </div>
          <div class="help-text">Минимальный период {{$store.getters.tariff.min_period_checker}} минут, максимальный 60 минут</div>
        </div>
      </div>
<button class="btn btn-primary save-data mt-2" @click="saveSettings"> Сохранить</button>
    </div>

    <div class="first-parser">
      <button v-if="!project.first_parser" class="btn btn-success" @click="$modal('show', 'start_parser')">Первый сбор</button>
      <div v-else>
        <button class="btn btn-success" disabled>Первый сбор был произведен {{$moment(project.first_parser).format("DD.MM.YY HH:mm")}}</button>

      </div>
    <modal modal_id="start_parser">
        <template v-slot:header>
          <h4>Запуск сбора данных</h4>
        </template>
        <template v-slot:body>

          <h6>Перед первым запуском сбора данных проверьте следующие настройки:</h6>
          <ul>
            <li> Загружены все необходимые ссылки</li>
            <li> Настроена глубина сбора</li>
            <li> Настроены теги для анализа отзывов</li>
          </ul>

        </template>
        <template v-slot:footer>
          <button type="button" class="btn btn-secondary" @click="$modal('hide', 'start_parser')"
                  data-bs-dismiss="modal">Отмена
          </button>
          <button type="button" class="btn btn-success" @click="startParser()"
                  data-bs-dismiss="modal">Запустить сбор
          </button>
        </template>
      </modal>
    </div>

  </div>

</template>

<script>

import moment from "moment";
import {ProjectApi} from "@/api/projects";


export default {
  name: 'ParserSettings',
  components: {},
  props: {},
  data() {
    return {
      settings: {},
      day_type: "few_days",
      day_types: [
        {
          name: 'Ежедневно',
          help: 'Запуск каждый день',
          value: 'everyday'
        },
        {
          name: 'Несколько раз в неделю',
          help: 'Выбрать дни недели',
          value: 'few_days'
        },
      ]
    }

  },
  watch: {
    day_type(value){
      if (value==='everyday') this.settings.restart_weekday = [...Array(7).keys()]
    }
  },
  mounted: function () {
    const $this = this;
    ProjectApi.get_review_settings(this.project_id).then(response => {
      $this.settings = response
      if ($this.settings.restart_weekday.length === 7) $this.day_type = $this.day_types[0].value
    })
  },
  computed: {
    weekdays() {
      const order =[1,2,3,4,5,6,0];
      return order.map(function (i) {
         return {
      'name': moment().day(i).format('dd'),
      'id': i
    };
      })
    },
    project_id: {
      get() {
        return this.$store.getters.currentProjectId
      },
      set(value) {
      }
    },
      project: {
      get() {
        return this.$store.getters.currentProject
      },
      set(value) {
      }
    }
  },

  methods: {
     validateMax(event) {
    const maxValue = this.$store.getters.tariff.max_period;
    let value = event.target.value;

    if (value > maxValue) {
      this.settings.restart_day_back = maxValue;
    }

    if (value < 0) {
      this.settings.restart_day_back = 0;
    }
  },
     validateMin(event) {
    const minValue = this.$store.getters.tariff.min_period_checker;
    let value = event.target.value;

    if (value < minValue) {
      this.settings.restart_checker_period = minValue;
    }

    if (value < 0) {
      this.settings.restart_checker_period = 0;
    }
  },

    startParser(){
       this.$modal('hide', 'start_parser');
       this.project.first_parser = this.$moment()
      ProjectApi.start_parser(this.project_id).then((response) => {
        if (response.error){
         this.$notify({
          type: "error",
          text: response.error
        })
        }
        else {
          this.$notify({
            type: "success",
            text: 'Сбор данных запущен'
          })
        }
      })
    },
    saveSettings() {
      const $this = this;
      ProjectApi.get_review_settings(this.project_id).then(response => {
        const settings = {
          ...response,
          ...$this.settings
        }
        ProjectApi.save_review_settings(this.project_id, settings).then(() => {
          $this.$notify({
            type: "success",
            text: 'Настройки сохранены'
          })
        })

      })
    },
    toggleDay(index) {
      const idx = this.settings.restart_weekday.indexOf(index);
      if (idx === -1) {
        this.settings.restart_weekday.push(index);
      } else {
        this.settings.restart_weekday.splice(idx, 1);
      }
    }
  }
}

</script>
<style scoped lang="scss">
.parser-days {
  .d-flex {
    gap: 10px;
    align-items: center;

    input {
      width: 100px;
    }

    label {
      font-size: 14px;
    }
  }

}

.add-time {
  border: 1px dashed var(--grey);
  width: 100%;
  margin-top: 10px;
}

.save-data {
  margin: 0 20px 20px auto;
}
.weekdays-selector .btn-group {
  flex-wrap: wrap;
  gap: 2px;
}
.weekdays-selector .btn {
  width: 32px;
  height: 32px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.first-parser{
  padding: 5px 5px 20px 15px;
}

</style>

